import { render, staticRenderFns } from "./PaymentInvoices.vue?vue&type=template&id=d1178978&scoped=true"
import script from "./PaymentInvoices.vue?vue&type=script&lang=js"
export * from "./PaymentInvoices.vue?vue&type=script&lang=js"
import style0 from "./PaymentInvoices.vue?vue&type=style&index=0&id=d1178978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1178978",
  null
  
)

export default component.exports